export const MasonryGrid = ({ children }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 md:gap-8 xl:gap-x-14 xl:gap-y-14 h-full">
            {children}
        </div>
    );
};
